export class Offerings {
    constructor(main, availableOfferings) {
        this.main = main;
        this.availableOffering = availableOfferings;
    }
    offeringForIdentifier(identifier) {
        return this.availableOffering.find((object) => object.id === identifier);
    }
}
//# sourceMappingURL=Offerings.js.map